<template>
  <a-card :bordered='false' style='border-left:2px solid #3BA1EB;margin-left: -2px;'>
    <a-divider orientation='left' style='margin-top: -5px;'>
      当前场地安排<span style='color: red' v-if='dataSource[0] && dataSource[0].isNew == 0'>(已取消)</span>
    </a-divider>
    <detail-list v-if='dataSource[0]'>
      <detail-list-item term='评标专家人数'><span>{{sessionEvalRoom.evalSeatSize}}</span></detail-list-item>
      <detail-list-item term='是否申请隔夜评标'><span>{{sessionEvalRoom.isOvernight == 0?"否":sessionEvalRoom.isOvernight == 1?"是":"暂无"}}</span></detail-list-item>
      <detail-list-item term='是否使用远程异地评标'><span>{{sessionEvalRoom.isOffsiteEvaluation == 0?"否":"是"}}</span></detail-list-item>
      <detail-list-item v-if="isShowCommionsionerAns" term='是否总监答辩' ><span>{{ isCommissionerAns === '1' ? "是" :"否" }}</span></detail-list-item>
    </detail-list>
    <detail-list v-if='dataSource[0]'>
     <detail-list-item term='开标开始时间' ><span :style="openRoom.roomType!=='1'?'color:red;':''">{{ openRoom == null ? "暂无场地安排记录" : openRoom.roomType === '4'? "开标时间待定":openRoom.roomType === '11'?"项目终止": openRoom.beginTime }}</span></detail-list-item>
      <detail-list-item term='开标结束时间'><span :style="openRoom.roomType!=='1'?'color:red;':''">{{ openRoom == null ? "&nbsp" : openRoom.roomType === '4'? "开标时间待定":openRoom.roomType === '11'?"项目终止": openRoom.endTime  }}</span></detail-list-item>
      <detail-list-item term='开标地点'><span :style="openRoom.roomType!=='1'?'color:red;':''">{{ openRoom == null ? "&nbsp" : openRoom.roomType === '11'?'项目终止':openRoom.roomName }}</span></detail-list-item>
      <detail-list-item term='评标开始时间'><span :style="openRoom.roomType!=='1'?'color:red;':''">{{ evalRoom == null ? "暂无场地安排记录" : evalRoom.roomType === '5'? "评标时间待定":evalRoom.roomType === '12'?"项目终止": evalRoom.beginTime}}</span></detail-list-item>
      <detail-list-item term='评标结束时间'><span :style="openRoom.roomType!=='1'?'color:red;':''">{{ evalRoom == null ? "&nbsp" :  evalRoom.roomType === '5'? "评标时间待定":evalRoom.roomType === '12'?"项目终止": evalRoom.endTime }}</span></detail-list-item>
      <detail-list-item term='评标地点'><span :style="openRoom.roomType!=='1'?'color:red;':''">{{ evalRoom == null ? "&nbsp" : evalRoom.roomType === '12'?'项目终止': evalRoom.roomName }}</span></detail-list-item>

    </detail-list>
    <a-divider orientation='left' style='margin-top: -5px;'>
      场地安排记录
    </a-divider>
    <a-table
      ref="table"
      bordered
      size="middle"
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="false"
      :loading="loading"
      @change="handleTableChange">
    </a-table>

    <div v-if="isRemoteEvaluation == '1' && isShowRemoteEvaluation">
      <a-divider orientation='left' style='margin-top: 100px;'>
        分会场安排 <span v-if="!sessionEvalRoom || !sessionEvalRoom.sessionApprovalStatus || sessionEvalRoom.sessionApprovalStatus == 1">(待审核)</span>
      </a-divider>
      <detail-list>
        <detail-list-item term='评标开始时间'>{{ evalRoom.beginTime }}</detail-list-item>
        <detail-list-item term='评标结束时间'>{{ evalRoom.endTime }}</detail-list-item>
        <detail-list-item term='评标地点'>{{ sessionEvalRoom.sessionVenueRoom }}</detail-list-item>
      </detail-list>
      <a-divider orientation='left' style='margin-top: -5px;'>
        场地安排记录
      </a-divider>
      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        style="width: 50%"
        :columns="sessionColumns"
        :dataSource="sessionDatasource"
        :pagination="false"
        :loading="loading"
        @change="handleTableChange">
      </a-table>
    </div>
    <a-button v-has="'room:reApply'" type="primary" style="margin-top: 20px" @click="handleReSchedule">场地重新申请</a-button>
    <RoomReApply-modal ref="modalForm" @ok="modalFormOk"></RoomReApply-modal>
  </a-card>
</template>

<script>
import DetailList from '@/components/tools/DetailList'
import {getAction, postAction} from '@/api/manage'
import {FzisListMixin} from '@/mixins/FzisListMixin'
const DetailListItem = DetailList.Item
import RoomReApplyModal from "@views/room/modules/RoomReApplyModal.vue";

export default {
  components: {
    DetailList,
    DetailListItem,
    RoomReApplyModal,
  },
  mixins: [FzisListMixin],
  name: 'RoomInfo',
  data() {
    return {
      bidProjectId: '',
      isRemoteEvaluation: '',
      isShowRemoteEvaluation: true,
      isShowCommionsionerAns:false,
      isCommissionerAns:null,
      roomList: [],
      sessionDatasource: [],
      evalRoom:{},
      sessionEvalRoom: {},
      openRoom:{},
      columns: [
        {
          title: '开标开始时间',
          align: "center",
          dataIndex: 'beginTime',
          customRender: function(text, r, index) {
            if ( r.roomType==='4') {
              return '开标时间待定'
            }else if( r.roomType==='11'){
              return '项目终止'
            } else {
              return text
            }
          }
        },
        {
          title: '开标结束时间',
          align: "center",
          dataIndex: 'endTime',
          customRender: function(text, r, index) {
          if (r.roomType==='4') {
            return '开标时间待定'
          } else if(r.roomType==='11'){
            return '项目终止'
          }
          else {
            return text
          }
        }
        },
        {
          title: '开标地点',
          align: "center",
          dataIndex: 'roomName',
          customRender: function(text, r, index) {
            if(r.roomType==='11'){
              return '项目终止'
            }
            else {
              return text
            }
          }
        },
        {
          title: '评标开始时间',
          align: "center",
          dataIndex: 'evalBeginTime',
          customRender: function(text, r, index) {
            if (text == null && r.roomType==='4') {
              return '评标时间待定'
            }else if(text == null && r.roomType==='11'){
              return '项目终止'
            } else {
              return text
            }
          }
        },
        {
          title: '评标结束时间',
          align: "center",
          dataIndex: 'evalEndTime',
          customRender: function(text, r, index) {
            if (text == null && r.roomType==='4') {
              return '评标时间待定'
            }else if(text == null && r.roomType==='11'){
              return '项目终止'
            }  else {
              return text
            }
          }
        },
        {
          title: '评标地点',
          align: "center",
          dataIndex: 'evalRoomName',
          customRender: function(text, r, index) {
            if(r.roomType==='11'){
              return '项目终止'
            }
            else {
              return text
            }
          }
        },
      ],
      sessionColumns: [
        {
          title: '评标开始时间',
          align: "center",
          dataIndex: 'evalBeginTime'
        },
        {
          title: '评标结束时间',
          align: "center",
          dataIndex: 'evalEndTime'
        },
        {
          title: '评标地点',
          align: "center",
          dataIndex: 'sessionVenueRoom'
        },
      ],
      url: {
        list: "",
      },
      disableMixinCreated: true,
    }
  },
  created() {

  },
  methods: {
    setBidProjectId(id, isRemoteEvaluation) {
      //1.根据招标编号ID获取招标项目信息和项目信息
      this.bidProjectId = id
      this.isRemoteEvaluation = isRemoteEvaluation;
      this.url.list = '/ebid-ce/tmRoomManager/roomPlanList/' + this.bidProjectId;
      this.loadData();

      let that = this;
      getAction("/ebid-ce/tmSecTender/queryEvalRoomByBidId/"+ this.bidProjectId, {}).then(res => {
        if (res.success && res.result) {
          that.evalRoom = res.result;
        }
      });

      let that2 = this;
      getAction("/ebid-ce/tmSecTender/queryOpenRoomByBidId/"+ this.bidProjectId, {}).then(res => {
        if (res.success && res.result) {
          that2.openRoom = res.result;
        }
      });

      // if (this.isRemoteEvaluation == '1') {
        // 获取分会场场地安排记录
        getAction("/ebid-ce/tmRoomManager/sessionRoomPlanList/" + this.bidProjectId).then(res => {
          if (res.success) {
            that.sessionEvalRoom = res.result[0];

            if (res.result[0].sessionVenueName === "省外远程异地"){
              that.isShowRemoteEvaluation = false;
            }

            if (res.result.length == 1 && (!res.result[0].sessionApprovalStatus || res.result[0].sessionApprovalStatus == 1)) {
              // 如果分会场申请记录只有一条，则判断是否是否正在审核，如果正在审核则置空
            } else {
              that.sessionDatasource = res.result;
            }
          } else {
            that.$message.warning("查询分会场安排失败，请稍后重试！")
          }
        });
      // }

    },
    loadData(arg) {
      if(this.isFirstLoad) {
        this.initParam = Object.assign(this.initParam,this.queryParam)
        this.isFirstLoad = false
      }
      if(!this.url.list){
        //this.$message.error("请设置url.list属性!")
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var params = this.getQueryParams();//查询条件

      this.loading = true;
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records||res.result;
          this.ipagination.total = res.result.total;
          this.$nextTick(() => {
            getAction('/ebid-ce/tmBidProject/queryById', {id: this.bidProjectId}).then(res => {
              if (res.result.tenderProjectClassifyCode === "A01A01A01A02" || res.result.tenderProjectClassifyCode === "A01A01A02A02") {
                //房建/市政的监理展示获取总监答辩
                let applyId = null;
                for (let i in this.dataSource) {
                  if (this.dataSource[i].isNew === "1") {
                    applyId = this.dataSource[i].applyId;
                  }
                }
                if (applyId) {
                  getAction('/room/apply/queryById', {id: applyId}).then(res => {
                    if (res.success) {
                      this.isCommissionerAns = res.result.isCommissionerAns;
                      this.isShowCommionsionerAns = true;
                    }

                  })
                }

              }
            });
          });
        }
        else if(res.code===510){
          this.$message.warning(res.message)
        } else {
          if(res.message){
            this.$message.warning(res.message)
          }else{
            this.$message.warning(res)
          }
        }

        this.loading = false;
      })
    },
    handleReSchedule() {
      this.$refs.modalForm.show(this.openRoom,this.evalRoom);
      this.$refs.modalForm.title = "重新分配";
      this.$refs.modalForm.disableSubmit = false;
    },
    modalFormOk(){
      this.setBidProjectId(this.bidProjectId, this.isRemoteEvaluation)
    }
  }
}
</script>

<style lang='less' scoped>

</style>